import * as React from 'react'
const styles = require('./styles.scss')

export const StepTitle = ({ children }) => <h2 className={styles.stepTitle}>{children}</h2>
